import React, { useState } from 'react';
import VideoModal from '../VideoModal';
import './TutorialVideoButton.css';

/**
 * Circular "?" button that opens a tutorial video.
 * Renders as a fixed-position FAB in the bottom-right corner.
 *
 * @param {string} [videoUrl] - YouTube embed URL (defaults to dashboard tutorial)
 * @param {string} [label] - Accessible label / tooltip text
 */
const DASHBOARD_TUTORIAL_URL = 'https://www.youtube.com/embed/u6Lp7E7sHgs?autoplay=1';

function TutorialVideoButton({ videoUrl = DASHBOARD_TUTORIAL_URL, label = 'Tutorial', className = '' }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className={`tutorial-video-fab ${className}`.trim()}
        onClick={() => setIsOpen(true)}
        aria-label={`Watch ${label.toLowerCase()} video`}
        title={label}
      >
        <span className="tutorial-video-fab__icon" aria-hidden="true">?</span>
      </button>

      <VideoModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        videoUrl={videoUrl}
      />
    </>
  );
}

export default TutorialVideoButton;
